export default {
    topics: [
        {
            title: ' body ',
            href: 'p-HttpClientResponse-body.html',
            attributes: { 'data-id': 'p-HttpClientResponse-body' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientResponse-body-d66e5458',
            topics: [],
        },
        {
            title: ' code ',
            href: 'p-HttpClientResponse-code.html',
            attributes: { 'data-id': 'p-HttpClientResponse-code' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientResponse-code-d66e5466',
            topics: [],
        },
        {
            title: ' codePage ',
            href: 'p-HttpClientResponse-codePage.html',
            attributes: { 'data-id': 'p-HttpClientResponse-codePage' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientResponse-codePage-d66e5474',
            topics: [],
        },
        {
            title: ' header ',
            href: 'p-HttpClientResponse-header.html',
            attributes: { 'data-id': 'p-HttpClientResponse-header' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientResponse-header-d66e5482',
            topics: [],
        },
        {
            title: ' headers ',
            href: 'p-HttpClientResponse-headers.html',
            attributes: { 'data-id': 'p-HttpClientResponse-headers' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientResponse-headers-d66e5490',
            topics: [],
        },
        {
            title: ' message ',
            href: 'p-HttpClientResponse-message.html',
            attributes: { 'data-id': 'p-HttpClientResponse-message' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientResponse-message-d66e5498',
            topics: [],
        },
    ],
};

